import { Link } from "react-router-dom";
import { newsCategories } from "@/mocks/newsCategories";
import { newsArticles } from "@/mocks/newsArticles";

const accentMap: Record<string, { bubble: string; icon: string }> = {
  primary: { bubble: "bg-primary-100 text-primary-700", icon: "text-primary-600" },
  accent: { bubble: "bg-accent-100 text-accent-800", icon: "text-accent-700" },
  secondary: { bubble: "bg-secondary-100 text-secondary-900", icon: "text-secondary-700" },
};

function CategoryGrid() {
  return (
    <section className="w-full px-4 md:px-10 py-14 md:py-20 bg-background-50">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-8">
        <div>
          <span className="inline-flex items-center gap-2 text-xs font-medium text-secondary-600 tracking-[0.2em]">
            <span className="w-6 h-px bg-secondary-500" />
            CATEGORIES
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl font-black text-foreground-950">
            按主题找瓜 · 六大速报线
          </h2>
        </div>
        <Link
          to="/category/all"
          className="inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
        >
          浏览全部快讯
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-right-line" />
          </span>
        </Link>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {newsCategories.map((cat) => {
          const count = newsArticles.filter((item) => item.category === cat.slug).length;
          const theme = accentMap[cat.accent] ?? accentMap.secondary;
          return (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 border border-background-200 rounded-lg p-6 cursor-pointer transition-colors hover:border-primary-300"
            >
              <div className="flex items-start justify-between">
                <span
                  className={`w-12 h-12 flex items-center justify-center rounded-lg ${theme.bubble} transition-transform duration-300 group-hover:-translate-y-1`}
                >
                  <i className={`${cat.icon} text-2xl`} />
                </span>
                <span className="text-xs text-foreground-500 whitespace-nowrap">{count} 条速报</span>
              </div>
              <h3 className="mt-5 font-heading text-lg font-bold text-foreground-950 group-hover:text-primary-600 transition-colors">
                {cat.name}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{cat.desc}</p>
              <span className="mt-5 inline-flex items-center gap-1.5 text-sm font-medium text-primary-600">
                进入这条线
                <span className="w-4 h-4 flex items-center justify-center transition-transform duration-300 group-hover:translate-x-1">
                  <i className="ri-arrow-right-line" />
                </span>
              </span>
            </Link>
          );
        })}
      </div>
    </section>
  );
}

export default CategoryGrid;